import React, { memo, useEffect, useState } from 'react'
import { string, func, object, element } from 'prop-types'
import {
  Container,
  Row,
  Col,
  Card,
  CaptionText,
  BodyText,
} from '@paypalcorp/pp-react'
import serverData from '../utils/server-data'
import { fptiCustomClick } from '../utils/fpti'

const DWSubSection = memo((props) => {
  const { locality = {}, isMobile, isNative } = serverData
  const directionality = locality.directionality || 'ltr'

  const {
    subSectionId,
    title,
    desc,
    icon,
    onSectionClick,
    subModule = {},
  } = props

  const [isSmallScreen, setIsSmallScreen] = useState(false)
  const resizeScreen = () => setIsSmallScreen(window.innerWidth <= 576),
    subModuleEnabled = Object.keys(subModule).length > 0 && subModule.enabled()

  useEffect(() => {
    resizeScreen()
    if (subModuleEnabled) {
      window.addEventListener('resize', resizeScreen)
    }
    return () => window.removeEventListener('resize', resizeScreen)
  }, [])

  const handleSectionClick = (navigateTo, modal, fptiClickData) => {
    fptiCustomClick(fptiClickData || {})
    if (!modal) {
      top.location.href = navigateTo
    } else {
      onSectionClick(modal)
    }
  }

  const onClickSubSection = (type) => {
    if (!type) {
      handleSectionClick(props.navigateTo, props.modal, props.fptiClickData)
    }
    if (type === 'subModule') {
      const { modal: subModuleModal = null, navigateTo: subnavigateTo } =
        subModule
      handleSectionClick(subnavigateTo, subModuleModal, subModule.fptiClickData)
    }
  }

  const onClickSubModule = (e) => {
    e.stopPropagation()
    e.preventDefault()
    onClickSubSection('subModule')
    return false
  }

  const removeSubSectionHoverEffect = () => {
    const card = document.getElementById(subSectionId)
    const buttons = card.getElementsByClassName('dw-sub-section-card')
    buttons[0].classList.add('dw-sub-section-card-hover')
  }

  const addSubSectionHoverEffect = () => {
    const card = document.getElementById(subSectionId)
    const buttons = card.getElementsByClassName('dw-sub-section-card')
    buttons[0].classList.remove('dw-sub-section-card-hover')
  }

  const getSubModule = () => {
    const subModuletitle = (
      <BodyText className="dw-sub-module-title">{subModule.title}</BodyText>
    )
    const subModuleDesc = <CaptionText>{subModule.desc}</CaptionText>
    const subModuleBadge = subModule.badgeStatus()

    return isNative || isMobile || isSmallScreen ? (
      <Col className={`dw-sub-module-col ${directionality}`}>
        {subModuletitle}
        {subModuleBadge}
        {subModuleDesc}
      </Col>
    ) : (
      <>
        <Col>
          {subModuletitle}
          {subModuleDesc}
        </Col>
        <Col xs={1} />
        <Col xs="auto">{subModuleBadge}</Col>
      </>
    )
  }

  return (
    <div id={subSectionId}>
      <Row row={{ justifyContent: 'center' }} noGutters>
        <Col xs={12} sm={8}>
          <Card
            onClick={() => onClickSubSection()}
            className="dw-sub-section-card"
          >
            <Container fluid className="dw-sub-section-container">
              <Row row={{ justifyContent: 'start' }} noGutters>
                <Col
                  xs="auto"
                  className={`dw-subsection-icon-container ${directionality}`}
                >
                  {icon}
                </Col>
                <Col>
                  <section
                    className={`dw-subsection-row-container ${directionality}`}
                  >
                    <BodyText className="dw-sub-section-title">
                      {title}
                    </BodyText>
                    {desc && (
                      <CaptionText className="dw-sub-section-desc">
                        {desc}
                      </CaptionText>
                    )}
                  </section>
                </Col>
              </Row>
              {subModuleEnabled && (
                <Row
                  id={subModule.subModuleId}
                  row={{ justifyContent: 'start' }}
                  noGutters
                  className="dw-sub-module"
                >
                  <Col
                    xs="auto"
                    className={`dw-sub-module-icon-container ${directionality}`}
                  >
                    {icon}
                  </Col>
                  <Col>
                    <Card
                      className={`dw-sub-module-card ${directionality}`}
                      onClick={(e) => onClickSubModule(e)}
                      onMouseEnter={() => removeSubSectionHoverEffect()}
                      onMouseLeave={() => addSubSectionHoverEffect()}
                    >
                      <Container fluid className="dw-sub-module-container">
                        <Row noGutters className="dw-sub-module-row">
                          {getSubModule()}
                        </Row>
                      </Container>
                    </Card>
                  </Col>
                </Row>
              )}
            </Container>
          </Card>
        </Col>
      </Row>
    </div>
  )
})

DWSubSection.propTypes = {
  subSectionId: string,
  title: object,
  desc: object,
  icon: element,
  fptiClickData: object,
  navigateTo: string,
  modal: object,
  subModule: object,
  onSectionClick: func,
}

DWSubSection.displayName = 'DWSubSection'

export default DWSubSection
